module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"gallery_title":"Photo Gallery","gallery_zip":"Gallery Download (zip)"},"ja":{"gallery_title":"画像ギャラリー","gallery_zip":"画像一括ダウンロード"}}')
  delete Component.options._Ctor
}
